import React, { Component } from 'react';
import { compose, branch, renderNothing } from 'recompose';
import { Avatar, Popover } from '@nextiva/next-ui-components';
import { userConfigPropType } from 'constants';

import UserDropdownItem from './UserDropdownItem';

import './UserButton.scss';

class UserButton extends Component {
  static propTypes = {
    config: userConfigPropType,
  };
  state = {
    isPopoverOpen: false,
    anchorEl: null,
  };

  getPopoverBody = () => {
    const {
      config: { options = [] },
    } = this.props;

    return (
      <div className="nx-current-user-dropdown">
        {options.map((item) => {
          return <UserDropdownItem key={item.label} item={item} />;
        })}
      </div>
    );
  };

  togglePopover = (e) => {
    const { isPopoverOpen } = this.state;

    this.setState({
      ...this.state,
      anchorEl: e.currentTarget,
      isPopoverOpen: !isPopoverOpen,
    });
  };

  getInitials = (name) => {
    const words = name.split(' ');
    let result;

    switch (true) {
      // name has a couple of words
      case words.length > 1:
        // eslint-disable-next-line no-case-declarations
        const lastName = words.pop() || '';

        result = [name.charAt(0), lastName.charAt(0)].join('');
        break;
      // one word name
      case name.length > 2:
        result = name.charAt(0);
        break;
      // one or two letters already
      default:
        result = name;
    }

    return result.toUpperCase();
  };

  render() {
    const { isPopoverOpen, anchorEl } = this.state;
    const {
      config: { name },
    } = this.props;
    const initials = this.getInitials(name);

    return (
      <div className="nx-current-user-button">
        <Avatar
          onClick={this.togglePopover}
          className="m-global-header__user-button m-global-header__user-button--old-avatar"
        >
          {initials}
        </Avatar>
        <Popover
          open={isPopoverOpen}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          onClose={this.togglePopover}
        >
          {this.getPopoverBody()}
        </Popover>
      </div>
    );
  }
}

export default compose(branch((props) => !props.config, renderNothing))(UserButton);
